(function bsgShippingBar() {
  var THRESHOLD = 4000; // $40.00 in cents

  function setBarContent(el, totalCents) {
    var fill = el.querySelector('.bsg-shipping-bar__fill');
    var msg  = el.querySelector('.bsg-shipping-bar__msg');
    if (!fill || !msg) return;

    var pct = Math.min(100, (totalCents / THRESHOLD) * 100);
    fill.style.width = pct + '%';

    if (totalCents >= THRESHOLD) {
      el.dataset.unlocked = '1';
      msg.innerHTML = '<span class="bsg-shipping-bar__icon">🚚</span>You\'ve unlocked free shipping!';
    } else {
      delete el.dataset.unlocked;
      var remaining = ((THRESHOLD - totalCents) / 100).toFixed(2);
      msg.innerHTML = '<span class="bsg-shipping-bar__icon">🛒</span>Add $' + remaining + ' more for free shipping';
    }
  }

  function updateDrawer(totalCents) {
    document.querySelectorAll('.bsg-shipping-bar').forEach(function (bar) {
      setBarContent(bar, totalCents);
    });
  }

  function fetchAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateDrawer(cart.total_price); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }

  document.addEventListener('shopify:cart:lines-update', fetchAndUpdate);
})();
